import React from 'react';
import QRCode from "react-qr-code";

export type QRCodeProps = {
    value: string;
    size?: number;
    floating?: boolean;
    title?: string;
}

const QRCodeComponent = ({value, size, title, floating}: QRCodeProps) => {
    return (
        <div className={`${floating ? 'floating-QR' : 'docking-QR'} ontario-margin-bottom-32-!`}>
            <QRCode 
                value={value}
                size={size}
                xlinkTitle={title ?? ''}
            />
        </div>
    )
    
};

export default QRCodeComponent;